<div class="bg-light-surface dark:bg-dark-surface rounded-xl flex flex-col gap-3 !p-6 overflow-hidden">
  <div class="flex items-center gap-2">
    <div class="flex-shrink-0">
      @if (state === 'success') {
        <lucide-angular [img]="CircleCheckBig" class="w-5 h-5 text-green-600 dark:text-green-400"></lucide-angular>
      } @else if (state === 'error') {
        <lucide-angular [img]="TriangleAlert" class="w-5 h-5 text-red-600 dark:text-red-400"></lucide-angular>
      } @else {
        <lucide-angular [img]="FileDown" class="w-5 h-5 text-light-primary dark:text-dark-primary"></lucide-angular>
      }
    </div>
    <h1 class="!mb-0">
      @if (state === 'loading') {
        Exportando base de conocimiento
      } @else if (state === 'success') {
        Exportación terminada
      } @else if (state === 'error') {
        Error de exportación
      } @else {
        Confirmar exportación
      }
    </h1>
  </div>

  @if (state === 'confirm') {
    <p class="text-light-text-secondary dark:text-dark-text-secondary">
      {{ getMessage() }}
    </p>

    @if (data.description) {
      <p class="text-sm text-light-text-secondary dark:text-dark-text-secondary !mb-0">
        {{ data.description }}
      </p>
    }

    @if (data.environmentLabel) {
      <p class="text-sm font-medium text-light-text dark:text-dark-text !mb-0">
        Ambiente a exportar: {{ data.environmentLabel }}
      </p>
    }

    @if (hasIdentifiers()) {
      <div
        class="bg-light-surface-hover dark:bg-dark-surface-hover rounded-lg p-4 border border-light-border dark:border-dark-border"
        [class.max-h-40]="shouldShowScrollableList()"
        [class.overflow-y-auto]="shouldShowScrollableList()">
        <h3 class="!mb-1">Artículos a exportar:</h3>
        <ul class="space-y-1 text-sm text-light-text-secondary dark:text-dark-text-secondary">
          @for (article of data.articles; track article) {
            <li class="flex items-center gap-2">
              <span class="w-1.5 h-1.5 rounded-full bg-light-primary dark:bg-dark-primary flex-shrink-0"></span>
              <span>{{ article.identifier }}</span>
            </li>
          }
        </ul>
      </div>
    }
  } @else if (state === 'loading') {
    <div class="flex flex-col items-center gap-4 py-6 text-center">
      <mat-spinner diameter="44"></mat-spinner>
      <p class="text-light-text-secondary dark:text-dark-text-secondary !mb-0">
        {{ feedbackMessage }}
      </p>
    </div>
  } @else {
    <div class="py-4">
      @if (data.environmentLabel) {
        <p class="text-sm font-medium text-light-text dark:text-dark-text">
          Ambiente exportado: {{ data.environmentLabel }}
        </p>
      }
      <p class="text-light-text-secondary dark:text-dark-text-secondary !mb-0">
        {{ feedbackMessage }}
      </p>
    </div>
  }

  <div class="flex items-center justify-end gap-3 mt-5">
    @if (state === 'confirm') {
      <button
        (click)="onCancel()"
        class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
        Cancelar
      </button>
      <button
        (click)="onConfirm()"
        class="flex gap-2 items-center font-medium !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl h-10 !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed duration-200">
        <lucide-angular [img]="Download" class="w-5 h-5"></lucide-angular>
        Exportar
      </button>
    } @else if (state === 'error') {
      <button
        (click)="onCancel()"
        class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
        Cerrar
      </button>
      <button
        (click)="onConfirm()"
        class="flex gap-2 items-center font-medium !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl h-10 !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all duration-200">
        Reintentar
      </button>
    }
  </div>
</div>
